import "../css/reset.css";
import Container from "../components/Layout/Container.js";
import StudyDetailComponents from "../components/StudyDetailComponents/StudyDetailComponents.js";
function StudyDetailPage() {
  return (
    <Container>
      <StudyDetailComponents />
    </Container>
  );
}

export default StudyDetailPage;
